import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson38: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson37"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Vitamins</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson39"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-justify">
          <p className="m-0">
            <b>
              Vitamins and minerals are nutrients your body needs in small
              amounts to work properly and stay healthy.
            </b>
          </p>
          <p className="m-0">
            <b>&nbsp;</b>
          </p>
          <p className="m-0">
            Most people should get all the nutrients they need by having a
            varied and balanced diet, although some people may need to take
            extra supplements.
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>
                  <span>Vitamin A</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>
                    Vitamin A, also known as retinol, has several important
                    functions.
                  </b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>These include:</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>
                      helping your body's natural defence against illness and
                      infection (the immune system) work properly
                    </span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>helping vision in dim light</span>
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    <span>
                      keeping skin and the lining of some parts of the body,
                      such as the nose, healthy
                    </span>
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.81rem] object-cover"
            alt=""
            src="/224@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Vitamin A Sources</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Good sources of vitamin A (retinol) include:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>eggs</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>cheese</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Oily Fish</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Milk & Yogurt`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>
                  liver and liver products such as liver pâté – this is a
                  particularly rich source of vitamin A, so you may be at risk
                  of having too much vitamin A if you have it more than once a
                  week (if you're pregnant you should avoid eating liver or
                  liver products)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                You can also get vitamin A by including good sources of
                beta-carotene in your diet, as the body can convert this into
                retinol.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>The main food sources of beta-carotene are:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  yellow, red and green (leafy) vegetables, such as spinach,
                  carrots, sweet potatoes and red peppers
                </span>
              </span>
            </li>
            <li>
              <span>
                <span>yellow fruit, such as mango, papaya and apricots</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>
                  <span>Vitamin B</span>
                </span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>
                  <span>&nbsp;</span>
                </b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <b>There are many different types of vitamin B.</b>
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  <span>This section has information on:</span>
                </span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>thiamin (vitamin B1)</span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>riboflavin (vitamin B2)</span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>niacin (vitamin B3)</span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>vitamin B6</span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>biotin (vitamin B7)</span>
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    <span>folate and folic acid</span>
                  </span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    <span>vitamin B12</span>
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <img
            className="relative w-[34.63rem] h-[19.44rem] object-cover"
            alt=""
            src="/225@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Thiamin (Vitamin B1)</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Thiamin, also known as vitamin B1, helps:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>the body break down and release energy from food</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>keep the nervous system healthy</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Thiamin is found in many types of food.</span>
              </span>
            </p>
          </div>
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-[1.88rem]">
            <p className="m-0">
              <b>Thiamin Sources</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <p className="m-0 text-[1.56rem]">Good sources include:</p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>peas</span>
              </li>
              <li className="mb-[0rem]">
                <span>Fresh Fruits</span>
              </li>
              <li className="mb-[0rem]">
                <span>Nuts</span>
              </li>
              <li className="mb-[0rem]">
                <span>Wholegrain Breads</span>
              </li>
              <li>
                <span>Liver</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Riboflavin (Vitamin B2)</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Riboflavin, also known as vitamin B2, helps:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>keep skin, eyes and the nervous system healthy</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>The body releases energy from food</span>
                </span>
              </li>
              <li>
                <span>
                  <span>
                    UV light can destroy riboflavin, so ideally these foods
                    should be kept out of direct sunlight.
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-[1.88rem]">
            <p className="m-0">
              <b>Riboflavin Sources</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>milk</span>
              </li>
              <li className="mb-[0rem]">
                <span>eggs</span>
              </li>
              <li className="mb-[0rem]">
                <span>mushrooms</span>
              </li>
              <li>
                <span>yoghurt</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Niacin (Vitamin B3)</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Niacin, also known as vitamin B3, helps:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>the body release energy from food</span>
                </span>
              </li>
              <li>
                <span>
                  <span>keep the nervous system and skin healthy</span>
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-[1.88rem]">
            <p className="m-0">
              <b>Niacin Sources</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>meat</span>
              </li>
              <li className="mb-[0rem]">
                <span>fish</span>
              </li>
              <li className="mb-[0rem]">
                <span>wheat flour</span>
              </li>
              <li>
                <span>eggs</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-[1.88rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] inline-block h-[17.88rem]">
            <p className="m-0">
              <b>
                <span>Vitamin B6</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    the body to use and store energy from protein and
                    carbohydrates in food
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 text-[1.56rem] pl-[2.06rem]">
              <li>
                <span>
                  <span>
                    the body form haemoglobin, the substance in red blood cells
                    that carries oxygen around the body
                  </span>
                </span>
              </li>
            </ul>
          </div>
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] text-gainsboro-100">
            <p className="m-0">
              <b>Viramin B6 Sources</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>pork</span>
              </li>
              <li className="mb-[0rem]">
                <span>fish</span>
              </li>
              <li className="mb-[0rem]">
                <span>peanuts</span>
              </li>
              <li className="mb-[0rem]">
                <span>soya beans</span>
              </li>
              <li className="mb-[0rem]">
                <span>oats</span>
              </li>
              <li className="mb-[0rem]">
                <span>bananas</span>
              </li>
              <li>
                <span>milk</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] inline-block h-[22.13rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>{`Folate & Folic Acid`}</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  Folate is a B vitamin found in many foods. The manmade form of
                  folate is called folic acid.
                </span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Folate helps:</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>the body form healthy red blood cells</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>
                    reduce the risk of birth defects called neural tube defects,
                    such as spina bifida, in unborn babies
                  </span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A lack of folate could lead to folate deficiency anaemia.
                </span>
              </span>
            </p>
          </div>
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-[1.88rem]">
            <p className="m-0">
              <b>Foltate Sources</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>broccoli</span>
              </li>
              <li className="mb-[0rem]">
                <span>brussel sprouts</span>
              </li>
              <li className="mb-[0rem]">
                <span>leafy green vegetables</span>
              </li>
              <li className="mb-[0rem]">
                <span>peas</span>
              </li>
              <li className="mb-[0rem]">
                <span>chickpeas</span>
              </li>
              <li>
                <span>liver</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem]">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0 text-[1.88rem]">
              <b>
                <span>Vitamin B12</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>Vitamin B12 is involved in helping the body:</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <ul className="m-0 pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>
                  <span>
                    make red blood cells and keeping the nervous system healthy
                  </span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>release energy from food</span>
                </span>
              </li>
              <li className="mb-[0rem]">
                <span>
                  <span>use folate</span>
                </span>
              </li>
            </ul>
            <p className="m-0">
              <span>
                <span>&nbsp;</span>
              </span>
            </p>
            <p className="m-0">
              <span>
                <span>
                  A lack of vitamin B12 could lead to vitamin B12 deficiency
                  anaemia.
                </span>
              </span>
            </p>
          </div>
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem] text-gainsboro-100 text-[1.88rem]">
            <p className="m-0">
              <b>Vitamin B12 Sources</b>
            </p>
            <p className="m-0">
              <b>&nbsp;</b>
            </p>
            <ul className="m-0 text-[1.5rem] pl-[2.06rem]">
              <li className="mb-[0rem]">
                <span>meat</span>
              </li>
              <li className="mb-[0rem]">
                <span>milk</span>
              </li>
              <li className="mb-[0rem]">
                <span>cheese</span>
              </li>
              <li>
                <span>eggs</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-justify text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>
                <span>Vitamins Overview</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <b>
                  Vitamins and minerals are nutrients your body needs in small
                  amounts to work properly and stay healthy.
                </b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Most people should get all the nutrients they need by having a
                  varied and balanced diet, although some people may need to
                  take extra supplements.
                </span>
              </span>
            </span>
          </p>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson39"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson38;
